module.exports = __webpack_public_path__ + "static/img/home_logo.1f27f9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_logo.png
// module id = tESk
// module chunks = 3